// extracted by mini-css-extract-plugin
export default {"modal":"vC-z","addItemButton":"wC-z","plusCircle":"xC-z","branchVisible":"yC-z"};